import { RichText } from "components/RichTextWidget";
import {
  Action,
  Container,
  Heading2,
  Heading6,
  Icon,
  Paragraph,
} from "shared/components";
import { useOffsetScroll } from "shared/hooks";

import styles from "./Hero028.module.scss";

export const Hero028 = ({ payload, position }) => {
  const headline = payload?.headline ?? "";
  const subtitle = payload?.subtitle ?? "";
  const description = payload?.description ?? "";
  const buttonText = payload?.button?.buttonText ?? "";
  const widgetOffset = payload?.button?.widgetOffset ?? 0;

  const { scrollToTarget } = useOffsetScroll({
    widgetOffset,
    position,
  });

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.content}>
          <div className={styles.top}>
            <Heading2 className={styles.headline} color="dark">
              {headline}
            </Heading2>
            <Action onClick={scrollToTarget} className={styles.play}>
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="large_arrow_down" />
              </span>
              <Paragraph color="brand" appearance="bold">
                {buttonText}
              </Paragraph>
            </Action>
          </div>
          <div className={styles.bottom}>
            <Heading6 className={styles.subtitle} color="dark">
              {subtitle}
            </Heading6>
            <RichText value={description} className={styles.description} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Hero028;
